export const MODAL_IDS = {
  verification_bonus_info_modal: 'verification_bonus_info_modal',
  verification_success_modal: 'verification_success_modal',
  account_delete_action_modal: 'account_delete_action_modal',
  account_delete_confirm_modal: 'account_delete_confirm_modal',
  increased_income: 'increased_income',
  every_5_bonus_group_a: 'every_5_bonus_group_a',
  brand_detail_modal: 'brand_detail_modal',
  happy_brands: 'happy_brands',
  two_factor_auth_modal: 'two_factor_auth_modal',
  veriff_modal: 'veriff_modal',
  review_participation: 'review_participation',
  streak_activity_detail: 'streak_activity_detail',
  streak_status_modal: 'streak_status_modal',
  report_download_modal: 'report_download_modal',
  period_select_modal: 'period_select_modal',
  date_range_modal: 'date_range_modal',
  operation_types_select_modal: 'operation_types_select_modal',
  report_reference_modal: 'report_reference_modal',
  cash_movement_detail: 'cash_movement_detail',
  portfolio_movement_detail: 'portfolio_movement_detail',
  change_email_modal: 'change_email_modal',
  brands_for_investment: 'brands_for_investment',
  brands_filled_for_investment: 'brands_filled_for_investment',
  new_brands_joined_round: 'new_brands_joined_round',
  brands_for_investment_status_modal: 'brands_for_investment_status_modal',
  compliance_submit_modal: 'compliance_submit_modal',
  early_reservation_modal: 'early_reservation_modal',
  decision_widget_onboarding: 'decision_widget_onboarding',
  country_verification: 'country_verification',
  bank_requisite_modal: 'bank_requisite_modal',
  payment_method_select_modal: 'payment_method_select_modal',
  review_top_up_modal: 'review_top_up_modal',
  top_up_result_modal: 'top_up_result_modal',
  withdraw_select_modal: 'withdraw_select_modal',
  review_withdraw_modal: 'review_withdraw_modal',
  bank_account_under_review: 'bank_account_under_review',
  bank_account_remove_modal: 'bank_account_remove_modal',
  bank_account_add_warning_modal: 'bank_account_add_warning_modal',
};
